export default __webpack_public_path__ + "media/src/assets/images/MapPinPickup-4e325edbc61c18a6d591eff412c2f1c4.svg";